/*eslint-disable */
define(["jquery"], function($) {
    var CHECKED_CLASS = "checked";

    function maintainCheckedClassOnLabels($radioInputs) {
        var $initiallyCheckedRadioInput = $radioInputs.filter(":checked");
        var $labels = getLabels();

        getLabel($initiallyCheckedRadioInput).addClass(CHECKED_CLASS);
        $radioInputs.on("change", changed);

        function changed() {
            var $radioInput = $(this);
            var $label = getLabel($radioInput);

            $labels.removeClass(CHECKED_CLASS);
            $label.addClass(CHECKED_CLASS);
        }

        function getLabels() {
            var $labels;

            // Try <input> as child of <label>.
            //
            //   <label>
            //     <input type="radio".../>
            //   </label>
            $labels = $radioInputs.parent("label");

            // If not found labels, then assume <input> and <label> are siblings.
            //
            //   <something>
            //     <input ... id="abc" type="radio".../>
            //     <label for="abs">...</label>
            //   </something>
            if ($labels.length === 0) {
                $labels = $radioInputs.parent().find("label");
            }

            return $labels;
        }

        function getLabel($radioInput) {
            var id = $radioInput.attr("id");
            var $label;

            if (id) {
                $label = $labels.filter("[for=" + id + "]");
            }

            if (!$label || $label.length === 0) {
                $label = $radioInput.parent("label");
            }

            return $label;
        }
    }

    return {
        maintainCheckedClassOnLabels: maintainCheckedClassOnLabels
    };
});
